
import state from './../../zviz2/zviz/state';
import TextBox from './../../zviz2/zviz/components/textbox';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import config from './../../config';
import {styleText} from './../../styles';
import {extend, cloneObject} from './../../zviz2/zviz/functions';


class Controller extends GroupController{

    constructor(parent, blueprint={}){
        super(parent, blueprint);        
    }

    getValue(col){
        let result = '';
        let column = this.parent.data.columns[col] || false;
        if(column){
            if(! this.showId(column)){
                return '';
            }
            if(col == 0 && state.get('renderSize') == 'small'){
                return '';
            }
        }
        if(column === 'rec_desc'){
            return 'Recommendation description and management response (if already completed)';
        }
        return config.data.dimensionTitles[column] || column;
    }

    showId(column){
        
        if(column === 0){
            column = this.parent.data.columns[column] || false;
            if(state.get('renderSize') == 'small'){
                return false;
            }
        }
        let noIds = ['ll_id', 'gp_id', 'rec_id'];
        return (noIds.indexOf(column) == -1);
    }

    getOrder(col){
        let column = this.parent.data.columns[col] || false;
        let order = state.get('order');
        if(order.field == column){
            return (order.direction>0)? ' \u25B4': ' \u25BE';
        }
        return '';
    }

    setOrder(col){
        let column = this.parent.data.columns[col] || false;
        let order = state.get('order');
        let direction = 1;
        if(order.field == column){
            direction = -1 * order.direction;
        }
        state.set('order', {field: column, direction: direction});

    }


} 


let Blueprint = extend({
    properties: { 
        style: { clear: 'both' }
     },
    children: [
        (parent) => (extend({
            type: Controller,
            listeners: [
                (ctrl) => (ctrl.addListener(state, [ctrl, ctrl.update], 'order'))
            ],
            properties: {
                style: {
                    display: 'block',
                    backgroundColor: 'white',
                    padding: '0px 0px 5px 0px' 
                },
                data: {
                    pd: cloneObject(parent.data)
                }
            },
            children: [ 
                extend({
                    properties: {
                        style: { 
                            display: 'inline-block',
                            width: (ctrl) => ( (state.get('renderSize') == 'small')? '10%' : '5%'),
                            verticalAlign: 'bottom',
                        },
                        content: ''
                    }
                },TextBox),
                
                (ctrl) => (ctrl.showId(0) ? 
                    extend({
                        properties: {
                            style: extend({
                                display: 'inline-block',
                                width: '15%',
                                verticalAlign: 'bottom',
                                fontSize: '10pt',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                color: '#263062',
                                textDecoration: 'underline'
                            }, styleText),
                                content: (ctrl) => (ctrl.parent.getValue(0) + ctrl.parent.getOrder(0))
                        },
                        events: {
                            click: (event, ctrl) => { ctrl.parent.setOrder(0); }
                        }
                    },TextBox) :
                    []
                ),

                extend({
                    properties: {
                        style: extend({
                            display: 'inline-block',
                            width: (ctrl) => ( ctrl.parent.showId(0)? '69%': ((state.get('renderSize') == 'small')? '79%': '84%') ),
                            verticalAlign: 'bottom',
                            fontSize: '10pt',
                            fontWeight: 'bold',
                            color: '#263062',
                            cursor: 'pointer',
                            textDecoration: 'underline'
                        }, styleText),
                        content: (ctrl) => ( ctrl.parent.getValue(1) + ctrl.parent.getOrder(1) )
                    },
                    events: {
                        click: (event, ctrl) => { ctrl.parent.setOrder(1); }
                    }
                },TextBox),

                extend({
                    properties: {
                        style: extend({
                            display: 'inline-block',
                            width: '10%',
                            verticalAlign: 'bottom',
                            fontSize: '10pt',
                            fontWeight: 'bold',
                            color: '#263062',
                            textAlign: 'center',
                            cursor: 'pointer',
                            textDecoration: 'underline'
                        }, styleText),
                        content: (ctrl) => ( ctrl.parent.getValue(2) + ctrl.parent.getOrder(2) )
                    },
                    events: {
                        click: (event, ctrl) => { ctrl.parent.setOrder(2); }
                    }
                },TextBox)
            ]
        }, Group) )
    ]

}, Group);


export default Blueprint;
export {Controller, Blueprint};

